import React from "react";
import { MdOutlineAddCircle, MdArrowBackIos } from "react-icons/md";
import { HiMicrophone } from "react-icons/hi2";

import { PreviewLayout } from ".";
import { Lazy } from "@/components/Lazy";

import { QRProps } from "@/contexts/QREditorContext/types";

export default function PreviewSMS(props: QRProps<"sms">) {
  const isInitPreview = props.initPreview;
  const { message, phoneNumber } = props.data;

  const defaultMessage = props.data.message;
  const defaultName = "Laura";

  return (
    <PreviewLayout
      page="sms"
      dataQA="preview-sms-container"
      isInitPreview={isInitPreview}
    >
      <div className="preview-sms__header">
        <div className="preview-sms__header__back">
          <MdArrowBackIos />
        </div>
        <div className="preview-sms__header__profile">
          <div className="preview-sms__header__profile__image__container">
            <Lazy placeholderClass="preview-sms__header__profile__image__background">
              <img
                src="/images/phone-previews/defaultPreview/sms.png"
                alt="sms-avatar"
                className="preview-sms__header__profile__image__background"
              />
            </Lazy>
          </div>
          <div className="preview-sms__header__profile__name">
            {isInitPreview ? defaultName : phoneNumber || defaultName}
          </div>
        </div>
      </div>
      <div className="preview-sms__content">
        <div className="preview-sms__content__container">
          <div className="preview-sms__content__container__add-icon">
            <MdOutlineAddCircle />
          </div>
          <div className="preview-sms__content__container__message-container">
            <div className="preview-sms__content__container__message-container__text">
              <p className={`sms-message ${isInitPreview ? "InitPreview" : ""}`}>
                {isInitPreview ? defaultMessage : message || defaultMessage}
              </p>
            </div>
            <div className="preview-sms__content__container__message-container__voice">
              <HiMicrophone />
            </div>
          </div>
        </div>
      </div>
    </PreviewLayout>
  );
}
